import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { StoreProvider, useStore } from "@/store/store";
import { AppShell } from "@/components/layout/AppShell";
import { Toaster } from "@/components/ui/sonner";
import Today from "@/pages/Today";
import Inbox from "@/pages/Inbox";
import Customers from "@/pages/Customers";
import Calendar from "@/pages/Calendar";
import Insights from "@/pages/Insights";
import Settings from "@/pages/Settings";
import Setup from "@/pages/Setup";
import Onboarding from "@/pages/Onboarding";
import { LanguageDocumentSync } from "@/i18n";

function RootEntry() {
  const { state } = useStore();
  const needsSelfServeSetup = state.onboarding?.mode === "self_serve" && !state.onboarding?.reviewedAt;
  return <Navigate to={needsSelfServeSetup ? "/onboarding" : "/today"} replace />;
}

function App() {
  return (
    <StoreProvider>
      <LanguageDocumentSync />
      <BrowserRouter>
        <Routes>
          <Route path="/setup" element={<Setup />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/" element={<RootEntry />} />
          <Route element={<AppShell />}>
            <Route path="/today" element={<Today />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/inbox/:id" element={<Inbox />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/:id" element={<Customers />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/:tab" element={<Settings />} />
            <Route path="*" element={<Navigate to="/today" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </StoreProvider>
  );
}

export default App;
